function isSet(value) {
  return value !== null && value !== undefined && value !== "";
}

const PADDING_KEYS = {
  top: "builderWithBorderPaddingTop",
  right: "builderWithBorderPaddingRight",
  bottom: "builderWithBorderPaddingBottom",
  left: "builderWithBorderPaddingLeft",
};

// VCL styleGuide slots take a bare token; an unwrapped {value,source} would otherwise fail silently.
function styleToken(value, option) {
  if (!isSet(value)) {
    return null;
  }
  if (typeof value === "object") {
    // eslint-disable-next-line no-console
    console.error(`Story input: option "${option}" reached the editor as ${JSON.stringify(value)}, not a style token; `
      + "it was dropped and the theme default applies. Unwrap it (appInputResolvedValue) before passing it on.");
    return null;
  }
  return value;
}

function storyEditorStyleOverrides({
  borderRadius = null,
  backgroundColor = null,
  borderColor = null,
  borderWidth = null,
  padding = {},
} = {}) {
  const overrides = {};
  if (isSet(borderRadius)) {
    overrides.builderBorderRadius = borderRadius;
  }
  if (isSet(backgroundColor)) {
    overrides.backgroundColor = backgroundColor;
    overrides.hoverBackgroundColor = backgroundColor;
  }
  const color = styleToken(borderColor, "border-color");
  if (color !== null) {
    overrides.builderBorderColor = color;
  }
  const width = styleToken(borderWidth, "border-width");
  if (width !== null) {
    overrides.builderBorderWidth = width;
  }
  let padded = false;
  Object.entries(PADDING_KEYS).forEach(([side, key]) => {
    const value = styleToken(padding?.[side], `padding.${side}`);
    if (value !== null) {
      overrides[key] = value;
      padded = true;
    }
  });
  // Segments add their own inline gutter; zero it so the option is the true text inset.
  if (padded) {
    overrides.paddingBetweenItems = "none";
  }
  return overrides;
}

function storyInputShellStyleOverrides(margins = {}) {
  return { ...margins };
}

module.exports = { storyEditorStyleOverrides, storyInputShellStyleOverrides };
